module.exports = __webpack_public_path__ + "static/media/0.22bfb63d.png";